import type {
  CommentProof,
  ImagesProof,
  SignatureProof,
  TaskProofCreatedBy,
  TaskProofImage,
} from '../task/task.interface';
import { TASK_PROOF_TYPE } from '../task/task.interface';
import { ObjectFactory } from './object.factory';

const DEFAULT_CREATED_BY: TaskProofCreatedBy = {
  firstName: 'Kevin',
  lastName: 'Martin',
  userId: 'aabbccddeeff001122334466',
};

const DEFAULT_IMAGES: TaskProofImage[] = [
  { originalUrl: 'https://example.com/photo-1.jpg', thumbnailUrl: 'https://example.com/photo-1-thumb.jpg' },
  { originalUrl: 'https://example.com/photo-2.jpg', thumbnailUrl: 'https://example.com/photo-2-thumb.jpg' },
];

/** Fields shared by every proof variant, excluding the type-specific discriminant fields (comment/signature/images/type). */
type TaskProofBaseFields = Omit<CommentProof, 'comment' | 'type'>;

function buildBaseProof(): TaskProofBaseFields {
  return {
    createdAt: new Date('2026-05-24T14:18:00.000Z'),
    createdBy: DEFAULT_CREATED_BY,
    id: 'aabbccddeeff001122334455',
  };
}

export class TaskProofFactory extends ObjectFactory<CommentProof> {
  protected getDefaults(): CommentProof {
    return {
      ...buildBaseProof(),
      comment: 'Left at the front door as requested.',
      type: TASK_PROOF_TYPE.COMMENT,
    };
  }

  /** Builds a signature proof (single image/URL). */
  buildSignature(overrides: Partial<SignatureProof> = {}): SignatureProof {
    return {
      ...buildBaseProof(),
      signature: 'https://example.com/signature.png',
      type: TASK_PROOF_TYPE.SIGNATURE,
      ...overrides,
    };
  }

  /** Builds an images proof (multiple photos). */
  buildImages(overrides: Partial<ImagesProof> = {}): ImagesProof {
    return {
      ...buildBaseProof(),
      images: DEFAULT_IMAGES,
      type: TASK_PROOF_TYPE.IMAGES,
      ...overrides,
    };
  }
}

export const taskProofFactory = new TaskProofFactory();
